import { useCallback, useEffect, useMemo, useState } from "react";
import { resolveMissingRequiredFields } from "../Views/DCMViewer/utils/form_required_validation_utils";

const mergeFormValues = (initialData, liveFormData) => ({
  ...(initialData || {}),
  ...(liveFormData || {}),
});

export default function useFormRequiredValidation(
  components,
  initialData,
  formRef
) {
  const [liveFormData, setLiveFormData] = useState(initialData || {});
  const [formRenderVersion, setFormRenderVersion] = useState(0);

  useEffect(() => {
    setLiveFormData((previousValues) =>
      mergeFormValues(initialData, previousValues)
    );
  }, [initialData]);

  const mergedFormData = useMemo(
    () => mergeFormValues(initialData, liveFormData),
    [initialData, liveFormData]
  );

  const missingFields = useMemo(
    () =>
      resolveMissingRequiredFields({
        formRef,
        components,
        data: mergedFormData,
      }),
    [formRef, components, mergedFormData, formRenderVersion]
  );

  const handleFormChange = useCallback((submission) => {
    setLiveFormData((previousValues) => ({
      ...(previousValues || {}),
      ...(submission?.data || {}),
    }));
  }, []);

  const handleFormRender = useCallback(() => {
    setFormRenderVersion((version) => version + 1);
  }, []);

  return {
    missingFields,
    isFormComplete: missingFields.length === 0,
    handleFormChange,
    handleFormRender,
    mergedFormData,
    resolveMissingFields: () =>
      resolveMissingRequiredFields({
        formRef,
        components,
        data: mergedFormData,
      }),
  };
}
